import {
	IonBadge,
	IonCol,
	IonGrid,
	IonItem,
	IonLabel,
	IonList,
	IonRow,
} from "@ionic/react";
import React from "react";
import { useHistory } from "react-router";
import { getTodayString } from "../../../../services/util";

interface props {
	user: any;
	dates: any;
}

const OverDueEntriesList: React.FC<props> = ({ user, dates }) => {
	const history = useHistory();
	const todayString = getTodayString();
	// useEffect(()=>{
	//   console.log(dates);
	// },[dates]);

	const _notToday = (date: any) => {
		return date !== todayString;
	};

	return (
		<>
			{dates &&
				dates
					.filter((el: any) => _notToday(el.dateField))
					.map((el: any, idx: any) => (
						<IonItem
							button
							key={idx}
							onClick={() =>
								history.push(`/users/${user.uid}/date/${el.timestamp}`)
							}
						>
							<IonGrid>
								<IonRow>
									<IonCol sizeLg="9" sizeMd="8" sizeXs="12">
										<IonLabel className="bold">{el.dateString}</IonLabel>
									</IonCol>
									<IonCol sizeLg="3" sizeMd="4" sizeXs="12">
										{el.status === "overdue" && (
											<IonBadge color="danger">Overdue</IonBadge>
										)}
										{el.status === "incomplete" && (
											<IonBadge color="warning">Incomplete</IonBadge>
										)}
									</IonCol>
								</IonRow>
							</IonGrid>
						</IonItem>
					))}
			{dates.filter((el: any) => _notToday(el.dateField)).length < 1 && (
				<IonItem lines="none">
					<span>You're up to date!</span>
				</IonItem>
			)}
		</>
	);
};

export default OverDueEntriesList;
